import { motion } from "framer-motion";
import { Truck, Wine, PackageCheck, Droplets } from "lucide-react";

export const STAGES = [
  { icon: Truck, title: "Deliver", text: "Bottles are delivered to the hospitality partner." },
  { icon: Wine, title: "Enjoy", text: "Guests experience a thoughtfully presented water service." },
  { icon: PackageCheck, title: "Collect", text: "Used bottles are collected according to the agreed schedule." },
  { icon: Droplets, title: "Clean & Refill", text: "Eligible bottles are professionally washed, inspected, sanitised, and refilled under the applicable quality process." },
];

const POS = ["left-1/2 top-0 -translate-x-1/2 -translate-y-1/2", "right-0 top-1/2 translate-x-1/2 -translate-y-1/2", "left-1/2 bottom-0 -translate-x-1/2 translate-y-1/2", "left-0 top-1/2 -translate-x-1/2 -translate-y-1/2"];
const LABEL = ["bottom-full mb-3 left-1/2 -translate-x-1/2 text-center", "top-full mt-3 left-1/2 -translate-x-1/2 text-center", "top-full mt-3 left-1/2 -translate-x-1/2 text-center", "top-full mt-3 left-1/2 -translate-x-1/2 text-center"];
// Four quarter arcs with gaps, each ending in an arrowhead (clockwise).
const ARCS = ["M 165.8 5 A 130 130 0 0 1 255 94.2", "M 255 165.8 A 130 130 0 0 1 165.8 255", "M 94.2 255 A 130 130 0 0 1 5 165.8", "M 5 94.2 A 130 130 0 0 1 94.2 5"];

export const Cycle = () => (
  <div className="w-full">
    <div className="relative mx-auto aspect-square w-[72%] max-w-[340px]" data-testid="sustainability-cycle">
      <svg viewBox="0 0 260 260" className="absolute inset-0 h-full w-full overflow-visible" fill="none" aria-hidden="true">
        <defs>
          <marker id="arrow" viewBox="0 0 10 10" refX="6" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse">
            <path d="M 0 1 L 8 5 L 0 9" fill="none" stroke="#B18A4A" strokeWidth="1.3" />
          </marker>
        </defs>
        <circle cx="130" cy="130" r="98" stroke="#B18A4A" strokeOpacity=".18" strokeDasharray="2 5" />
        {ARCS.map((d, i) => (
          <motion.path key={d} d={d} stroke="#B18A4A" strokeWidth="1.2" markerEnd="url(#arrow)"
            initial={{ pathLength: 0 }} whileInView={{ pathLength: 1 }} viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 1.1, delay: 0.3 + i * 0.35, ease: "easeInOut" }} />
        ))}
      </svg>
      <div className="absolute inset-0 grid place-items-center text-center">
        <p className="font-sans text-[10px] font-bold uppercase leading-[2] tracking-[0.3em] text-[#26231F] sm:text-[11px]">Returnable<br />Bottle<br />Programme</p>
      </div>
      {STAGES.map(({ icon: Icon, title }, i) => (
        <div key={title} className={`absolute ${POS[i]}`}>
          <span className="grid h-12 w-12 place-items-center rounded-full border border-[#B18A4A]/50 bg-[#F8F3E9] text-[#B18A4A] sm:h-14 sm:w-14">
            <Icon className="h-5 w-5" strokeWidth={1.1} aria-hidden="true" />
          </span>
          <span className={`absolute hidden w-max text-[10px] font-bold uppercase tracking-[0.24em] text-[#26231F] sm:block ${LABEL[i]}`}>{title}</span>
        </div>
      ))}
    </div>
    <ol className="mt-16 grid gap-6 sm:grid-cols-2">
      {STAGES.map((s, i) => (
        <li key={s.title} className="flex gap-4">
          <span className="font-serif-lux text-2xl leading-none text-[#B18A4A]">0{i + 1}</span>
          <div>
            <h3 className="font-sans text-[11px] font-bold uppercase tracking-[0.24em] text-[#26231F]">{s.title}</h3>
            <p className="mt-1.5 text-[13px] leading-relaxed text-[#746D64]">{s.text}</p>
          </div>
        </li>
      ))}
    </ol>
  </div>
);
